import { ICopyable } from '../controls/common/icopyable';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { IEmailAddress } from './interfaces/email-address.interface';

export class EmailAddress implements ICopyable<EmailAddress>, IDisplayableItem {
    public id: number = null;
    public organizationId: string = null;
    public address: string = null;
    public isActive: boolean = false;
    public sendingEnabled: boolean = false;
    public emailDisplayName: string;

    public createCopy(): EmailAddress {
        const instance = new EmailAddress();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.address = this.address;
        instance.isActive = this.isActive;
        instance.sendingEnabled = this.sendingEnabled;
        instance.emailDisplayName = this.emailDisplayName;

        return instance;
    }

    public static createFormCopy(emailAddress: EmailAddress): IEmailAddress {
        const instance = new EmailAddress();
        instance.id = emailAddress.id;
        instance.organizationId = emailAddress.organizationId;
        instance.address = emailAddress.address;
        instance.isActive = emailAddress.isActive;
        instance.sendingEnabled = emailAddress.sendingEnabled;
        instance.emailDisplayName = emailAddress.emailDisplayName;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.address = other.address;
        this.isActive = other.isActive;
        this.sendingEnabled = other.sendingEnabled;
        this.emailDisplayName = other.emailDisplayName;
    }

    public getDisplayName() {
        return `${this.address}`;
    }

    get displayName(): string {
        return `${this.address}`;
    }
}
